"use strict";
/**
 * @packageDocumentation
 * @module CType
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOwner = exports.decode = exports.store = void 0;
const utils_1 = require("@kiltprotocol/utils");
const config_1 = require("@kiltprotocol/config");
const chain_helpers_1 = require("@kiltprotocol/chain-helpers");
const log = config_1.ConfigService.LoggingFactory.getLogger('CType');
/**
 * @param ctype
 * @internal
 */
async function store(ctype) {
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    log.debug(() => `Create tx for 'ctype.add'`);
    const tx = blockchain.api.tx.ctype.add(ctype.hash);
    return tx;
}
exports.store = store;
/**
 * @param encoded
 * @internal
 */
// decoding is not backwards compatible with mashnet-node 0.22 anymore
function decode(encoded) {
    utils_1.DecoderUtils.assertCodecIsType(encoded, ['Option<AccountId>']);
    return !encoded.isEmpty ? encoded.toString() : null;
}
exports.decode = decode;
/**
 * @param ctypeHash
 * @internal
 */
async function getOwner(ctypeHash) {
    const blockchain = await chain_helpers_1.BlockchainApiConnection.getConnectionOrConnect();
    const encoded = await blockchain.api.query.ctype.cTYPEs(ctypeHash);
    const queriedCTypeAccount = decode(encoded);
    return queriedCTypeAccount;
}
exports.getOwner = getOwner;
